import React, { lazy, Suspense } from "react";
import LazyLoader from "../../components/common/loader/lazyLoader";
const CreatePassword = lazy(() =>
  import("../../components/forgetPassword/createPassword")
);

const CreatePasswordPage = () => {
  return (
    <Suspense fallback={<LazyLoader />}>
      <CreatePassword />
    </Suspense>
  );
};

export default CreatePasswordPage;
